module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai21-3b7c224db380eaf031892753b7437a6a.jpg";